import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { styled } from '@mui/material/styles';
import CheckIcon from '@mui/icons-material/Check';
import { borderColor, borderRadius, fontSize, height, lineHeight, margin, padding, width } from '@mui/system';
import { getStartedWizard } from '../url/SvgLinks';
import zIndex from '@mui/material/styles/zIndex';
import { getDynamicBorder, getStringProduct } from '../utils/utilityFunctions';
import { Box } from '@mui/material';

//common code for astepper active, completed and pending
const StepperConnectorCommon = {
  // width: '100%',
  // background: '#B0B0B0',
  // height: '100%',

  // borderColor: 'transparent',
  // position: 'relative'
  // '&::before': {
  //   position: 'absolute',
  //   content: '""',
  //   width: '100%',
  //   top: '-1px',
  //   height: '31px',
  //   // borderBottomRightRadius: '10px',
  //   // background: 'yellow',
  //   border: '4px solid #B0B0B0',
  //   borderRadius: '50%',
  //   borderTop: 'none',
  //   borderRight: 'none',
  //   borderLeft: 'none',
  //   transform: 'rotate(180deg)'
  // },
  // '&::after': {
  //   position: 'absolute',
  //   content: '""',
  //   width: '100%',
  //   top: '-30px',
  //   height: '31px',
  //   // borderBottomRightRadius: '50px',
  //   // background: 'yellow',
  //   border: '4px solid #B0B0B0',
  //   borderTop: 'none',
  //   borderRadius: '50%',
  //   borderTop: 'none',
  //   borderRight: 'none',
  //   borderLeft: 'none'
  //   // borderBottomLeftRadius: '50px'
  //   // transform: 'rotate(180deg)'
  // }

  // background: `url(${getStartedWizard.stepperSvg})`,
  // // height: '15px',
  // height: '100%',
  // width: '100%',
  // // marginLeft: '-4px',
  // backgroundSize: '100%',
  // backgroundRepeat: 'no-repeat',
  // border: 'none',
  // margin: 'auto',
  // backgroundPositionY: 'center',
  // display: 'flex',
  // alignItems: 'center'

  // borderTopWidth: '8px',
  border: 'none',
  width: '100%',
  height: '8px',
  position: 'relative',
  background: '#B0B0B0'
  // boxShadow: 'inset 0px 4px 1px 0px #00000050',
  // outline: `1px solid #3598DB`,
  // '&::before, &::after': {
  //   content: '""',
  //   position: 'absolute',
  //   top: '50%',
  //   // transform: 'rotate(-47deg)',
  //   width: '25px', // Adjust the size of the circles
  //   height: '25px', // Adjust the size of the circles
  //   backgroundColor: '#B0B0B0',
  //   // outline: `1px solid #3598DB`,
  //   borderImage: 'linear-gradient(45deg, green, yellow)'
  // },
  // '&::before': {
  //   left: '-18px', // Adjust the position of the left circle
  //   top: '-8.57px',
  //   transform: 'rotate(-44deg)'
  // },
  // '&::after': {
  //   right: '-18px', // Adjust the position of the right circle
  //   top: '-8.57px',
  //   transform: 'rotate(-47deg)'
  // }
};

const useStyle = makeStyles((theme) => ({
  root: {
    boxShadow: 'none',
    // eslint-disable-next-line
    ['& .css-cveggr-MuiListItemIcon-root']: {
      color: '#fff'
    }
  },

  // removeBorder: {
  //   paddingLeft: 0,
  //   marginLeft: 0,
  // },
  selectStyle: {
    borderRadius: '20px'
  },
  cardPadding: {
    padding: '4px'
  },
  menuBar: {
    boxShadow: 'none'
  },

  //Side Bar Colors
  bgCardWrap: {
    // backgroundColor: '#333333 !important',
    // color: '#fff',
    border: 'none !important'
  },
  bgWrapLight: {
    color: '#fff',
    // eslint-disable-next-line
    ['& .MuiPaper-root']: {
      backgroundColor: '#1C1C1C',
      color: '#fff'
    }
  },
  bgWrapDark: {
    color: '#fff',
    // eslint-disable-next-line
    ['& .MuiPaper-root']: {
      backgroundColor: '#1C1C1C',
      color: '#fff'
    }
  },
  bgLight: {
    backgroundColor: '#1C1C1C',
    color: '#fff',
    '&:hover': {
      background: 'linear-gradient(to bottom,  #f7e7ac 0%,#f2ad3c 2%,#f7e7ac 100%)'
    }
  },
  bgDark: {
    backgroundColor: '#1C1C1C',
    color: '#fff',
    '&:hover': {
      background: 'linear-gradient(to bottom,  #f7e7ac 0%,#f2ad3c 2%,#f7e7ac 100%)'
    }
  },
  bgonly: {
    background: 'transparent'
  },
  white: {
    color: '#fff!important'
  },
  //Top Bar
  AppBarLight: {
    backgroundColor: 'transparent'
    // backgroundColor: '#FAFAFA'
  },
  AppBarLightSolid: {
    // backgroundColor: 'transparent'
    backgroundColor: '#FAFAFA'
  },
  AppBarDark: {
    backgroundColor: 'transparent'
    // backgroundColor: '#333333'
  },

  //Border Boxes
  boxWrapLight: {
    borderRadius: '10px !important',
    padding: '20px',
    marginBottom: '30px',
    background: '#fff'
  },
  boxWrapDark: {
    border: '1px solid #E3A33D',
    borderRadius: '10px !important',
    padding: '20px',
    marginBottom: '30px',
    background: theme.palette.background.box
    // background: "#333333 !important",
  },
  devider: {
    paddingTop: '20px',
    marginBottom: '20px !important'
  },

  //App Js Css
  AppLight: {
    // background: 'transparent',
    // backgroundImage: 'radial-gradient(circle, rgba(234,158,88,1) 0%, rgba(234,158,88,0) 84%)',
    // backgroundRepeat: 'no-repeat',
    // backgroundSize: 'cover',
    // height: '100%',
    // background: '#ECECEC',
    // marginLeft: '300px',
    width: '100%',
    maxWidth: '80vw',
    margin: 'auto',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100vw'
    }
  },
  AppDark: {
    // background: '#333131',
    width: '100%',
    maxWidth: '80vw',
    margin: 'auto',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100vw'
    }
  },
  //Overall Wrapper Root
  WrapperLight: {
    background: 'transparent',
    // opacity: 0.7,
    // filter: 'blur(498.333px)',
    // transform: 'rotate(0.14deg)',
    // padding: '80px 15px 0px 15px',
    // marginTop: '80px',
    marginBottom: '60px',
    height: '100%',

    // marginBottom: '50px',
    // padding: '55px 0px 0px 0px',
    [theme.breakpoints.down('md')]: {
      // padding: '80px 0px 0px 0px',
      marginBottom: '60px'
      // marginTop: '60px'
    },
    [theme.breakpoints.down('sm')]: {
      // padding: '80px 0px 0px 0px',
      marginBottom: '20px'
    }
    // background: '#ECECEC'
  },
  WrapperDark: {
    // padding: '80px 15px 0px 15px',
    // marginTop: '80px',
    marginBottom: '60px',
    height: '100%',
    // marginTop: '80px',
    [theme.breakpoints.down('md')]: {
      marginBottom: '60px'
      // marginTop: '60px'
      // padding: '80px 0px 0px 0px!important',
      // margin: 0
    },
    [theme.breakpoints.down('sm')]: {
      // padding: '80px 0px 0px 0px',
      marginBottom: '20px'
    }
    // background: '#333131'
  },
  // Freedom Activity Card
  FreedomActivity: {
    position: 'relative',
    background: 'transparent !important'
  },
  FreedomActivityHeader: {
    position: 'absolute',
    right: '10px',
    top: '0'
  },
  danger: {
    color: '#FF2E2E'
  },
  success: {
    color: '#25A140'
  },
  //Button Component
  ButtonLight: {
    padding: '16px 83px !important',
    backgroundColor: '#E3A33D',
    color: `${theme.palette.text.primary} !important`,
    fontWeight: '500'
  },
  ButtonDark: {
    padding: '10px 30px !important',
    backgroundColor: '#E3A33D',
    color: '#fff !important',
    fontWeight: '500'
  },
  Dollersign: {
    fontSize: '24px'
  },
  Pricefirst: {
    fontSize: '48px',
    fontWeight: '100'
  },
  PriceSecond: {
    fontSize: '24px'
  },
  right: {
    marginLeft: 'auto !important'
  },
  left: {
    float: 'right'
  },
  textRight: {
    textAlign: 'right'
  },
  progressFont: {
    fontSize: '14px !important'
  },
  headingFont: {
    fontSize: '20px !important',
    fontWeight: '500 !important'
  },
  labelhandle: {
    position: 'relative',
    // paddingTop: '10px',
    // eslint-disable-next-line
    ['& .MuiStepLabel-label']: {
      display: 'none !important'
    },

    // eslint-disable-next-line
    ['& .MuiStepLabel-label.Mui-active']: {
      display: 'block !important',
      position: 'absolute',
      width: '180px',
      top: '50%',
      left: '-50px',
      fontSize: '14px',
      [theme.breakpoints.down('sm')]: {
        width: '75px',
        top: '-8px',
        left: '-15px',
        fontSize: '9px'
      },
      textAlign: 'center'
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  stapingCardBalance: {
    paddingTop: '20px',
    border: 'none',
    // display: 'none',
    ['& .MuiStepConnector-root.Mui-active .MuiStepConnector-line']: {
      borderColor: 'red'
    },
    ['& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line']: {
      borderColor: 'green'
    },
    // eslint-disable-next-line
    ['& .css-z7uhs0-MuiStepConnector-line']: {
      borderColor: 'red !important',
      minHeight: 'auto'
    },
    [theme.breakpoints.up('xll')]: {
      paddingTop: getStringProduct(1.25, '20px')
    },
    [theme.breakpoints.up('xlll')]: {
      paddingTop: getStringProduct(1.66, '20px')
    },
    [theme.breakpoints.up('xl4')]: {
      paddingTop: getStringProduct(2.46, '20px')
    },
  },
  removeBorder: {
    border: 'none !important',
    paddingLeft: '0px!important',
    '&.css-14yr603-MuiStepContent-root': {
      padding: '0px!important',
      margin: '0px!important'
    }
  },
  sperater: {
    paddingTop: '15px !important',
    marginBottom: '15px !important'
  },
  imgFluid: {
    maxWidth: '100%',
    minHeight: 0
  },
  customLabelStyle: {
    [theme.breakpoints.up('xl4')]: {
      fontSize: '36px'
    }
  },
  stepWrap: {
    position: 'relative',
    padding: 0,
    '&.css-1bw0nnu-MuiStep-root:last-child': {
      padding: '0px!important'
    },
    '&.css-1bw0nnu-MuiStep-root': {
      padding: '0px!important'
    }
  },
  stepNumber: {
    position: 'absolute',
    top: '100%',
    left: '100%',
    [theme.breakpoints.down('sm')]: {
      top: '13px',
      left: '18px'
    },
    zIndex: '2'
  },
  typoPadding: {
    margin: '20px 0'
  },
  thumbnailwrap: {
    textAlign: 'center',
    padding: '15px 10px'
  },
  thumbColor: {
    color: '#888888',
    paddingTop: '3px',
    display: 'block'
  },
  CardBgTransparent: {
    background: 'transparent !important'
  },
  checkmiddle: {
    paddingTop: '10px',
    justifyContent: 'right'
  },
  lablemiddle: {
    paddingTop: '20px'
  },
  primarytypo: {
    marginTop: '10px'
  },
  pagination: {
    paddingTop: '15px'
  },
  SettingTypo: {
    padding: '10px'
  },
  expandIcon: {
    color: '#fff'
  },
  primaryColor: {
    color: '#E3A33D',
    paddingTop: '3px',
    display: 'block'
  },
  accordion: {
    padding: '0 10px'
  },
  text: {
    paddingBottom: '20px',
    marginLeft: '40px',
    [theme.breakpoints.up('xl4')]: {
      paddingBottom: getStringProduct(3, '20px'),
      marginLeft: getStringProduct(3, '40px'),
      fontSize: getStringProduct(3, '16px')
    }
  },
  textfilled: {
    marginRight: '5px'
  },
  typePadding: {
    paddingBottom: '20px',
    marginLeft: '70px'
  },
  codetext: {
    paddingBottom: '60px'
  },
  accordionitem: {
    padding: '0 !important',
    paddingLeft: '7px !important',
    marginLeft: '-8px',
    background: '#000',
    marginRight: '-11px'
  },
  accrodtionSummery: {
    paddingLeft: '7px !important',
    [theme.breakpoints.down('md')]: {
      paddingLeft: '28px !important'
    }
  },
  accrodtionSummery2: {
    paddingLeft: '30px !important',
    [theme.breakpoints.down('md')]: {
      paddingLeft: '28px !important'
    }
  },
  accordionitemtext: {
    paddingLeft: '0'
  },
  menutextonly: {
    paddingLeft: '7px',
    [theme.breakpoints.down('md')]: {
      paddingLeft: '0'
    }
  },
  menutext: {
    paddingRight: '20px'
  },
  amountcolor: {
    color: '#2BC155'
  },
  paddingBalance: {
    paddingLeft: '0 !important',
    marginLeft: '0 !important',
    border: 'none !important'
  },
  '& .css-13hkxlg-MuiStepConnector-line': {
    minHeight: 0
  },
  flex: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  accountAlert: {
    display: 'flex',
    background: '#333131',
    color: '#eee',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px 0'
  },
  error: {
    color: theme.palette.primary.error,
    fontSize: '0.75rem',
    marginLeft: '10px',
    fontWeight: 400,
    [theme.breakpoints.up('xl4')]: {
      fontSize: '2.25rem',
      marginLeft: '30px'
    }
  },

  ///customer styling
  headingTag: {
    letterSpacing: '1px',
    fontWeight: 600,
    fontSize: '2rem',
    color: theme.palette.primary.main
  },

  //connector
  connector: {
    '& .css-vnkopk-MuiStepLabel-iconContainer': {
      // paddingRight: '0px!important'
      // padding: 5,
      // background: '#B0B0B0',
      // boxShadow: 'inset 0px 2px 1px -1px #00000050',
      // zIndex: 10,
      // borderRadius: '50%'
    },
    '& .MuiStepConnector-line': {
      ...StepperConnectorCommon
    },
    '& .MuiStepConnector-root.Mui-active .MuiStepConnector-line': {
      // borderColor: '#B0B0B0',
      // boxShadow: '-3px 3px 5px #00000080',
      ...StepperConnectorCommon
    },
    '& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line': {
      // borderColor: theme.palette.primary.success,
      ...StepperConnectorCommon
    }
  },
  textContent: {
    [theme.breakpoints.down('sm')]: {
      order: '2'
    }
  },

  arrow: {
    [theme.breakpoints.down('sm')]: {
      order: '1'
    }
  },
  cancelButton: {
    [theme.breakpoints.down('sm')]: {
      order: '2'
    }
  },
  saveButton: {
    [theme.breakpoints.down('sm')]: {
      order: '1'
    }
  },
  rounded: {
    '& .MuiPaginationItem-root': {
      borderWidth: '2px'
    }
  }
}));

export default useStyle;

export const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[1000] : '#DADADA',
  zIndex: 1,
  color: theme.palette.text.primary,
  border: '4px solid #B0B0B0',
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  ['.css-mro3c9']: {
    paddingLeft: '0px !important',
    paddingRight: '0px !important'
  },
  [theme.breakpoints.down('sm')]: {
    // width: 40,
    // height: 40
  },
  [theme.breakpoints.up('xll')]: {
    border: getDynamicBorder(1.25, '4px solid #B0B0B0'),
    fontSize: getStringProduct(1.25, '16px')
  },
  [theme.breakpoints.up('xlll')]: {
    border: getDynamicBorder(1.66, '4px solid #B0B0B0'),
    fontSize: getStringProduct(1.66, '16px')
  },
  [theme.breakpoints.up('xl4')]: {
    border: getDynamicBorder(2.46, '4px solid #B0B0B0'),
    fontSize: getStringProduct(2.46, '16px')
  },
  // eslint-disable-next-line
  ['.MuiStep-root']: {
    position: 'relative',
    '& .css-mro3c9': {
      paddingLeft: '0px !important',
      paddingRight: '0px !important'
    }
  },
  // eslint-disable-next-line
  ['.MuiSvgIcon-root']: {
    display: 'none',
    backgroundImage: 'linear-gradient(45deg,  #d36221 0%,#eda138 100%);',
    borderRadius: '50%',
    margin: '20px'
  },

  ...(ownerState.active && {
    // boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    background: theme.palette.primary.main,
    boxShadow: 'inset 0px 3px 5px #000000 !important',
    padding: 0,
    // eslint-disable-next-line
    ['& .css-vnkopk-MuiStepLabel-iconContainer']: {
      padding: '10px !important',
      borderRadius: '50% !important',
      // boxShadow: '0 3px 5px #00000080',
      // background: 'greean',
      width: 50,
      height: 60,
      [theme.breakpoints.up('xll')]: {
        padding: `${getStringProduct(1.25, '10px')} !important`,
        width: getStringProduct(1.25, 50),
        height: getStringProduct(1.25,60)
      },
      [theme.breakpoints.up('xlll')]: {
        padding: `${getStringProduct(1.66, '10px')} !important`,
        width: getStringProduct(1.66, 50),
        height: getStringProduct(1.66,60)
      },
      [theme.breakpoints.up('xl4')]: {
        padding: `${getStringProduct(2.46, '10px')} !important`,
        width: getStringProduct(2.46, 50),
        height: getStringProduct(2.46,60)
      },
    },

    // eslint-disable-next-line
    ['.MuiSvgIcon-root']: {
      display: 'block',
      borderRadius: '50%',
      width: 30,
      height: 30,
       [theme.breakpoints.up('xll')]: {
        width: getStringProduct(1.25, 30),
        height: getStringProduct(1.25,30)
      },
      [theme.breakpoints.up('xlll')]: {
        width: getStringProduct(1.66, 30),
        height: getStringProduct(1.66,30)
      },
      [theme.breakpoints.up('xl4')]: {
        width: getStringProduct(2.46, 30),
        height: getStringProduct(2.46,30)
      },
    },
    backgroundColor: '#B0B0B0',
    zIndex: '4',
    // eslint-disable-next-line
    ['.MuiSvgIcon-root']: {
      display: 'block',
      backgroundColor: 'yellow',
      color: theme.palette.primary.primaryYellow,
      borderRadius: '50%',
      width: 30,
      height: 30
    }
  }),
  ...(ownerState.completed && {
    // border: `4px solid #B0B0B0 !important`,
    // backgroundColor: '#B0B0B0',
    padding: 0,
    width: 47,
    height: 47,
    background: '#00cc39',
    zIndex: '4',
    [theme.breakpoints.up('xll')]: {
      width: getStringProduct(1.25, 47),
      height: getStringProduct(1.25, 47),
      // border: `${getDynamicBorder(1.25, '4px solid #B0B0B0')} !important`
    },
    [theme.breakpoints.up('xlll')]: {
      width: getStringProduct(1.66, 47),
      height: getStringProduct(1.66, 47),
      border: `${getDynamicBorder(1.66, '4px solid #B0B0B0')} !important`
    },
    [theme.breakpoints.up('xl4')]: {
      width: getStringProduct(2.46, 47),
      height: getStringProduct(2.46, 47),
      border: `${getDynamicBorder(2.46, '4px solid #B0B0B0')} !important`
    },
    '& .css-a5nipc': {
      padding: 0
    },
    // background: theme.palette.primary.primayYellow,
    // backgroundImage: 'linear-gradient(45deg,  #d36221 0%,#eda138 100%);',
    // eslint-disable-next-line
    ['.MuiSvgIcon-root']: {
      display: 'block',
      background: theme.palette.primary.success,
      borderRadius: '50%',
      width: 38,
      height: 38,
      boxShadow: '0 3px 5px #00000080',
      [theme.breakpoints.up('xl4')]: {
        width: 114,
        height: 114,
        boxShadow: '0 6px 15px #00000080',
        border: `12px solid #fff !important`
      }
    }
  })
}));

export const StepperCircleStyle = styled('div')(({ theme, background }) => ({
  border: `2px solid ${theme.palette.primary.white}`,
  color: theme.palette.primary.white,
  background: background || theme.palette.primary.main,
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: 'inset 0px 0px 8px 1px  #00000050',
  [theme.breakpoints.up('xll')]: {
    border: getDynamicBorder(1.25, `2px solid ${theme.palette.primary.white}`),
    width: getStringProduct(1.25, '40px'),
    height: getStringProduct(1.25, '40px'),
    boxShadow: 'inset 0px 0px 24px 3px  #00000050'
  },
  [theme.breakpoints.up('xlll')]: {
    border: getDynamicBorder(1.66, `2px solid ${theme.palette.primary.white}`),
    width: getStringProduct(1.66, '40px'),
    height: getStringProduct(1.66, '40px'),
    boxShadow: 'inset 0px 0px 24px 3px  #00000050'
  },
  [theme.breakpoints.up('xl4')]: {
    border: getDynamicBorder(2.46, `2px solid ${theme.palette.primary.white}`),
    width: getStringProduct(2.46, '40px'),
    height: getStringProduct(2.46, '40px'),
    boxShadow: 'inset 0px 0px 24px 3px  #00000050'
  }
}));

export function ColorlibStepIcon(props) {
  const { active, completed, className } = props;
  const icons = {
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '5'
  };
  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {completed ? (
        <Box component="img" src={getStartedWizard.StepCompleted} sx={{ width: 30,margin: 'auto', width: '100%' }} />
      ) : active ? (
        <StepperCircleStyle>{icons[String(props.icon)]}</StepperCircleStyle>
      ) : (
        <StepperCircleStyle background={'#000000'}>{icons[String(props.icon)]}</StepperCircleStyle>
      )}
    </ColorlibStepIconRoot>
  );
}
ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node
};

// export const FreedomWrapperRoot = styled('div')(({ theme, ownerState }) => ({
// 	background: 'linear-gradient(180deg, #F6F2E6 0%, rgba(246, 242, 230, 0) 100%)',
// 	borderRadius: '15px',
// 	padding: '15px 16px',
// 	border: ` 0.76321px solid ${theme.palette.border.borderColor}`,
// 	maxHeight: '592px'
// }));
